// Legal documents — dates (2026-10-21). See LEGAL_REVISIONS.md.
//
// LEGAL_LAST_UPDATED: the "last updated" date shown on the Privacy Policy (HE / EN), the Terms of Service (HE / EN) and
// the registration copies in ConsentScreen. It must be the date the revision is PUBLISHED to production — set it here
// (one place for all documents) when the release date is final, and record it in LEGAL_REVISIONS.md.
export const LEGAL_LAST_UPDATED = { he: '25 באוקטובר 2026', en: 'October 25, 2026' };

// The Strava integration was discontinued on 21 October 2026 (Strava removal C1, production deploy). A historical
// fact stated in the documents — NOT the publication date above; it stays as written in the texts.
